import { render } from "./PdfInfoTooltip.vue?vue&type=template&id=c90732fc"
import script from "./PdfInfoTooltip.vue?vue&type=script&lang=js"
export * from "./PdfInfoTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__